// @ts-nocheck
import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, inject } from '@angular/core';
import moment from 'moment';

@Directive({
	selector: '[lbcaTable]',
})
export class TableDirective {
	el = inject(ElementRef);

	@Input('lbcaTable') colData: any;

	@Input() laneData: any;

	ngOnInit() {
		let innerHTML: string | null = null;

		let valor: unknown = null;

		if (this.colData.formatFunction) {
			valor = this.colData.formatFunction(this.laneData);
		} else {
			valor = this.laneData[this.colData.name];
		}

		if (this.colData.mask) {
			const masks = new Mask();
			valor = masks.data(valor);
		}

		const css = this.colData.css ? this.colData.css : '';

		if (valor === undefined) {
			innerHTML = `<div class="w-2  ml-[8px] h-[1px] mt-[2px] bg-gray-600"></div>`;
		} else {
			innerHTML = `<span class="${css} no-select text">${valor}</span>`;
		}

		this.el.nativeElement.innerHTML = innerHTML;
	}
}

class Mask {
	data(value) {
		if (!value) return '';
		const newValue = moment(value).format('DD / MM / YYYY [ÀS] HH:mm');
		return newValue;
	}
}

@Directive({
	selector: '[lbcaTableClickOutside]',
})
export class ClickTableOutsideDirective {
	el = inject(ElementRef);

	@Output('lbcaTableClickOutside')
	clickOutside = new EventEmitter();

	@HostListener('document:click', ['$event'])
	click(event) {
		setTimeout(() => {
			this.el.nativeElement.checked = false;
		}, 1);
	}
}
